<template>
  <div>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      <div class="alert-body">
        {{ errorText }}
      </div>
    </b-alert>

    <b-row class="mb-1">
      <b-col
        v-for="item in kinds"
        :key="item.kind"
        cols="12"
        sm="6"
        lg="3"
      >
        <b-card
          no-body
          class="cursor-pointer mb-1"
          :border-variant="item.kind === kind ? item.variant : ''"
          @click="select(item.kind)"
        >
          <b-card-body class="p-1">
            <div class="d-flex justify-content-between align-items-center">
              <h2 class="mb-0">
                <b-badge :variant="counts[item.kind] ? item.variant : 'light'">
                  {{ counts[item.kind] === undefined ? '…' : counts[item.kind] }}
                </b-badge>
              </h2>
            </div>
            <div class="font-weight-bolder mt-50">
              {{ item.title }}
            </div>
            <small class="text-muted">{{ item.hint }}</small>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card>
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-1">
        <h4 class="mb-0">
          {{ current.title }}
        </h4>
        <div class="d-flex align-items-center">
          <b-form-select
            v-model="period"
            :options="periodOptions"
            size="sm"
            class="mr-1"
            style="width: 11rem"
            @change="reload"
          />
          <b-button
            v-if="kind === 'stale_pending' && $perm('payment:manage')"
            variant="primary"
            size="sm"
            :disabled="sweeping"
            @click="sweep"
          >
            <b-spinner
              v-if="sweeping"
              small
            />
            Проверить в ЮKassa
          </b-button>
        </div>
      </div>

      <b-alert
        v-if="sweepResult"
        show
        variant="info"
        dismissible
        @dismissed="sweepResult = null"
      >
        <div class="alert-body">
          Проверено: {{ sweepResult.checked }}, статус изменился: {{ sweepResult.statusChanged }},
          ошибок: {{ sweepResult.errors }}.
          <span v-if="sweepResult.paidNotApplied.length">
            Оплачены, но не применены:
            <router-link
              v-for="payment in sweepResult.paidNotApplied"
              :key="payment.id"
              :to="{ name: 'payment-details', params: { id: payment.id } }"
              class="mr-50"
            >#{{ payment.id }}</router-link>
          </span>
        </div>
      </b-alert>

      <payment-events-table
        v-if="kind === 'unmatched_webhooks'"
        :rows="rows"
        :count="count"
        :page="page"
        :per-page="perPage"
        :loading="loading"
        show-payment
        @page="changePage"
      />
      <payments-table
        v-else
        :rows="rows"
        :count="count"
        :page="page"
        :per-page="perPage"
        :loading="loading"
        @page="changePage"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BCardBody, BCol, BFormSelect, BRow, BSpinner,
} from 'bootstrap-vue'
import moment from 'moment'
import paymentAdminApi from '@/services/payment-admin-api.service'
import PaymentsTable from './components/PaymentsTable.vue'
import PaymentEventsTable from './components/PaymentEventsTable.vue'
import { PROBLEM_KINDS, errorMessage } from './payment-labels'

const PER_PAGE = 20

export default {
  name: 'PaymentProblemsPage',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BFormSelect,
    BRow,
    BSpinner,
    PaymentsTable,
    PaymentEventsTable,
  },
  data() {
    return {
      kinds: PROBLEM_KINDS,
      counts: {},
      rows: [],
      count: 0,
      page: 1,
      perPage: PER_PAGE,
      loading: false,
      sweeping: false,
      sweepResult: null,
      errorText: '',
      period: 30,
      periodOptions: [
        { value: 7, text: 'За 7 дней' },
        { value: 30, text: 'За 30 дней' },
        { value: 90, text: 'За 90 дней' },
        { value: null, text: 'За всё время' },
      ],
    }
  },
  computed: {
    kind() {
      const asked = this.$route.query.kind
      return PROBLEM_KINDS.some(item => item.kind === asked) ? asked : PROBLEM_KINDS[0].kind
    },
    current() {
      return PROBLEM_KINDS.find(item => item.kind === this.kind)
    },
    range() {
      return this.period ? { from: moment().subtract(this.period, 'days').toISOString() } : {}
    },
  },
  watch: {
    kind() {
      this.page = 1
      this.sweepResult = null
      this.fetchList()
    },
  },
  created() {
    this.reload()
  },
  methods: {
    select(kind) {
      if (kind !== this.kind) this.$router.replace({ query: { ...this.$route.query, kind } })
    },
    reload() {
      this.page = 1
      this.fetchSummary()
      this.fetchList()
    },
    changePage(page) {
      this.page = page
      this.fetchList()
    },
    async fetchSummary() {
      try {
        const { data } = await paymentAdminApi.problemsSummary(this.range)
        this.counts = data
      } catch (e) {
        this.errorText = errorMessage(e)
      }
    },
    async fetchList() {
      this.loading = true
      this.errorText = ''
      try {
        const { data } = await paymentAdminApi.problems({
          kind: this.kind,
          skipCount: (this.page - 1) * this.perPage,
          maxResultCount: this.perPage,
          ...this.range,
        })
        this.rows = data.rows || []
        this.count = data.count || 0
      } catch (e) {
        this.errorText = errorMessage(e)
      } finally {
        this.loading = false
      }
    },
    async sweep() {
      this.sweeping = true
      try {
        const { data } = await paymentAdminApi.sweep(20)
        this.sweepResult = data
        this.reload()
      } catch (e) {
        this.errorText = errorMessage(e)
      } finally {
        this.sweeping = false
      }
    },
  },
}
</script>
